import(/* webpackMode: "eager" */ "/codebuild/output/src190029547/src/apps/webapp/src/app/global-error.tsx");
